class SalutProductIngredients extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector('.salut-ping__inner');
    this.toggle = this.querySelector('[data-ping-toggle]');
    this.labels = {
      more: this.toggle?.querySelector('[data-ping-toggle-label]')?.textContent.trim(),
      less: this.dataset.lessLabel,
    };

    this.addEventListener('click', this.onClick);

    this.querySelectorAll('.salut-ping-dialog').forEach((dialog) => {
      dialog.addEventListener('close', this.stopBackdropScroll);
    });
  }

  disconnectedCallback() {
    this.stopBackdropScroll();
  }

  // The dialog contains its own scroll with overscroll-behavior; only the backdrop needs blocking.
  // A scroll lock on <html> would turn it into a scroll container and drop the sticky gallery.
  blockBackdropScroll = (event) => {
    const dialog = this.querySelector('.salut-ping-dialog[open]');
    if (!dialog) return;

    const point = event.touches ? event.touches[0] : event;
    const box = dialog.getBoundingClientRect();
    const inside =
      point.clientX >= box.left &&
      point.clientX <= box.right &&
      point.clientY >= box.top &&
      point.clientY <= box.bottom;

    if (!inside) event.preventDefault();
  };

  startBackdropScroll() {
    document.addEventListener('wheel', this.blockBackdropScroll, { passive: false });
    document.addEventListener('touchmove', this.blockBackdropScroll, { passive: false });
  }

  stopBackdropScroll = () => {
    document.removeEventListener('wheel', this.blockBackdropScroll);
    document.removeEventListener('touchmove', this.blockBackdropScroll);
  };

  onClick = (event) => {
    const trigger = event.target.closest('[data-ping-open]');
    if (trigger) {
      this.open(trigger.dataset.pingOpen);
      return;
    }

    if (event.target.closest('[data-ping-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    if (event.target.closest('[data-ping-toggle]')) {
      this.onToggle();
      return;
    }

    const scroller = event.target.closest('[data-ping-scroll]');
    if (scroller) {
      this.scrollTrack(scroller);
      return;
    }

    if (event.target.matches('.salut-ping-dialog')) event.target.close();
  };

  onToggle() {
    const expanded = this.classList.toggle('salut-ping--expanded');
    this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    const label = this.toggle.querySelector('[data-ping-toggle-label]');
    if (label && this.labels.more && this.labels.less) {
      label.textContent = expanded ? this.labels.less : this.labels.more;
    }

    if (!expanded) this.inner?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  open(id) {
    const dialog = this.querySelector(`#${id}`);
    if (!dialog) return;

    dialog.showModal();
    this.startBackdropScroll();
    this.loadProducts(dialog);
  }

  async loadProducts(dialog) {
    const block = dialog.querySelector('[data-ping-products]');
    if (!block || block.dataset.pingLoaded || getComputedStyle(block).display === 'none') return;

    block.dataset.pingLoaded = 'true';
    const track = block.querySelector('[data-ping-track]');

    try {
      const response = await fetch(block.dataset.url);
      if (!response.ok) throw new Error(response.status);

      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const slides = (parsed.querySelector('.shopify-section') || parsed.body).innerHTML.trim();

      if (!slides) {
        block.hidden = true;
        return;
      }

      track.innerHTML = slides;
      this.updateNav(block);
    } catch (error) {
      block.hidden = true;
      console.error('Ingredients: could not load', block.dataset.url, error);
    }
  }

  updateNav(block) {
    const track = block.querySelector('[data-ping-track]');
    const overflows = track.scrollWidth > track.clientWidth + 1;
    block.querySelectorAll('[data-ping-scroll]').forEach((button) => {
      button.hidden = !overflows;
    });
  }

  scrollTrack(button) {
    const track = button.closest('.salut-ping-dialog__slider')?.querySelector('[data-ping-track]');
    if (!track) return;

    const slide = track.querySelector('.salut-ping-dialog__slide');
    const step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: step * Number(button.dataset.pingScroll), behavior: 'smooth' });
  }
}

if (!customElements.get('salut-product-ingredients')) {
  customElements.define('salut-product-ingredients', SalutProductIngredients);
}
